module.exports = __webpack_public_path__ + "img/Wendy-Navarro.2fd62f4b.png";